import { z } from "zod";

export const UserAnalyticsCleanupSchedule = z.object({
    userId: z.string(),
    createdAt: z.coerce.date(),
    deleteAt: z.coerce.date(),
});

export type UserAnalyticsCleanupSchedule = z.infer<typeof UserAnalyticsCleanupSchedule>;

export const UserAnalyticsCleanupScheduleDbInput = UserAnalyticsCleanupSchedule.omit({
    createdAt: true,
});

export type UserAnalyticsCleanupScheduleDbInput = z.infer<typeof UserAnalyticsCleanupScheduleDbInput>;
